import type { ParamsValidator } from "@whilecat/core/tasks/validators/params-validator.js";
import { isNotBlankArray } from "@whilecat/core/utils/string.js";
import { sanityCheck } from "@whilecat/core/utils/validation.js";
import type { TemplateResult } from "lit";

export type SpecialAnswers = {
    [key: string]: string;
};

export type CompleteSentenceParams = {
    answers: Array<string>;
    rightAnswers: Array<string>;
    specialAnswers?: SpecialAnswers | undefined;
    sentence: string;
    content?: TemplateResult | undefined;
};

export const CS_PLACEHOLDER = "@place_holder@";

export class CompleteSentenceParamsValidator implements ParamsValidator<CompleteSentenceParams> {
    validate(params: CompleteSentenceParams) {
        sanityCheck(isNotBlankArray(params.answers), "Possible answers must be present");
        sanityCheck(isNotBlankArray(params.rightAnswers), "Right answers must be present");
        sanityCheck(
            params.answers.length >= params.rightAnswers.length,
            "Possible answers must have the same or greater number of items",
        );

        sanityCheck(
            params.sentence.split(CS_PLACEHOLDER).length - 1 === params.rightAnswers.length,
            "Right answers must contain the same number of items as placeholders",
        );

        for (const option of params.rightAnswers) {
            sanityCheck(
                params.answers.includes(option),
                `Right answers must be present in answers, but "${option}" is missing.`,
            );
        }
    }
}
